(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-product-extras"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cb-look-carousel')) {
    customElements.define(
      'cb-look-carousel',
      class CbLookCarousel extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-look-track]');
          this.prev = this.querySelector('[data-look-prev]');
          this.next = this.querySelector('[data-look-next]');
          if (!this.track) return;

          this._onScroll = () => this.update();
          this.prev && this.prev.addEventListener('click', () => this.page(-1));
          this.next && this.next.addEventListener('click', () => this.page(1));
          this.track.addEventListener('scroll', this._onScroll, { passive: true });

          if ('ResizeObserver' in window) {
            this._ro = new ResizeObserver(() => this.update());
            this._ro.observe(this.track);
          } else {
            window.addEventListener('resize', this._onScroll);
          }
          this.update();
        }

        disconnectedCallback() {
          this._ro && this._ro.disconnect();
          window.removeEventListener('resize', this._onScroll);
        }

        page(dir) {
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.85, behavior: 'smooth' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const x = this.track.scrollLeft;
          if (this.prev) this.prev.disabled = x <= 4;
          if (this.next) this.next.disabled = x >= max - 4;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cb-recommendations')) {
    customElements.define(
      'cb-recommendations',
      class CbRecommendations extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-cb-track]');
          this.prev = this.querySelector('[data-cb-prev]');
          this.next = this.querySelector('[data-cb-next]');
          if (!this.track) return;

          this._onScroll = () => this.update();
          this.prev && this.prev.addEventListener('click', () => this.page(-1));
          this.next && this.next.addEventListener('click', () => this.page(1));
          this.track.addEventListener('scroll', this._onScroll, { passive: true });

          if ('ResizeObserver' in window) {
            this._ro = new ResizeObserver(() => this.update());
            this._ro.observe(this.track);
          } else {
            window.addEventListener('resize', this._onScroll);
          }

          this.update();
        }

        disconnectedCallback() {
          this._ro && this._ro.disconnect();
          window.removeEventListener('resize', this._onScroll);
        }

        page(dir) {
          this.track.scrollBy({ left: dir * this.track.clientWidth * 0.9, behavior: 'smooth' });
        }

        update() {
          const max = this.track.scrollWidth - this.track.clientWidth;
          const x = this.track.scrollLeft;
          const scrollable = max > 4;
          this.setAttribute('data-scrollable', scrollable ? 'true' : 'false');
          if (this.prev) this.prev.disabled = x <= 4;
          if (this.next) this.next.disabled = x >= max - 4;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-reviews-wall"] && !Shopify.designMode) return;
  try {
    
  class CBReviews extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.cb-rw__track');
      this.prev = this.querySelector('[data-dir="prev"]');
      this.next = this.querySelector('[data-dir="next"]');
      this.dots = this.querySelector('[data-dots]');
      if (!this.track) return;

      this._nav = (dir) => {
        const amount = Math.max(this.track.clientWidth, 260);
        this.track.scrollBy({ left: dir === 'next' ? amount : -amount, behavior: 'smooth' });
      };
      this.prev && this.prev.addEventListener('click', () => this._nav('prev'));
      this.next && this.next.addEventListener('click', () => this._nav('next'));

      this._update = () => this.update();
      this.track.addEventListener('scroll', this._update, { passive: true });

      this._build = () => this.buildDots();
      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(this._build);
        this._ro.observe(this.track);
      } else {
        window.addEventListener('resize', this._build);
      }
      this.buildDots();

      this.initModal();
      this.initLightbox();
    }

    initLightbox() {
      this.lightbox = this.querySelector('[data-review-lightbox]');
      if (!this.lightbox) return;
      const lbImg = this.lightbox.querySelector('[data-lightbox-img]');

      this._openLightbox = (btn) => {
        const src = btn.getAttribute('data-full-src');
        const img = btn.querySelector('img');
        if (!src) return;
        lbImg.src = src;
        lbImg.alt = img ? img.alt : '';
        this.lightbox.hidden = false;
        this.lightbox.classList.add('is-open');
        // forzar reflow para la transición de opacidad
        void this.lightbox.offsetWidth;
        this.lightbox.classList.add('is-visible');
        document.documentElement.style.overflow = 'hidden';
      };
      this._closeLightbox = () => {
        this.lightbox.classList.remove('is-visible');
        document.documentElement.style.overflow = '';
        setTimeout(() => {
          this.lightbox.classList.remove('is-open');
          this.lightbox.hidden = true;
          lbImg.src = '';
        }, 220);
      };

      this.querySelectorAll('[data-review-photo]').forEach((btn) =>
        btn.addEventListener('click', () => this._openLightbox(btn))
      );
      this.lightbox.addEventListener('click', (e) => {
        if (e.target === this.lightbox || e.target.closest('[data-lightbox-close]')) this._closeLightbox();
      });
      this._lbKey = (e) => { if (e.key === 'Escape' && !this.lightbox.hidden) this._closeLightbox(); };
      document.addEventListener('keydown', this._lbKey);
    }

    pageCount() {
      const t = this.track;
      if (t.clientWidth <= 0) return 1;
      const maxScroll = t.scrollWidth - t.clientWidth;
      if (maxScroll <= 4) return 1;
      return Math.ceil(maxScroll / t.clientWidth) + 1;
    }

    currentPage(pages) {
      const t = this.track;
      if (t.clientWidth <= 0) return 0;
      const n = pages || this.pageCount();
      if (t.scrollLeft + t.clientWidth >= t.scrollWidth - 2) return n - 1;
      return Math.min(n - 1, Math.round(t.scrollLeft / t.clientWidth));
    }

    buildDots() {
      const scrollable = this.track.scrollWidth > this.track.clientWidth + 4;
      this.setAttribute('data-scrollable', scrollable ? 'true' : 'false');
      if (this.dots) {
        const n = scrollable ? this.pageCount() : 0;
        if (this.dots.childElementCount !== n) {
          this.dots.innerHTML = '';
          for (let i = 0; i < n; i++) {
            const b = document.createElement('button');
            b.type = 'button';
            b.className = 'cb-rw__dot';
            b.setAttribute('aria-label', 'Página ' + (i + 1));
            b.addEventListener('click', () => {
              this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
            });
            this.dots.appendChild(b);
          }
        }
      }
      this.update();
    }

    update() {
      const t = this.track;
      const scrollable = t.scrollWidth > t.clientWidth + 4;
      const pages = this.pageCount();
      const page = this.currentPage(pages);
      if (this.prev) this.prev.disabled = !scrollable || page <= 0;
      if (this.next) this.next.disabled = !scrollable || page >= pages - 1;
      if (this.dots) {
        Array.from(this.dots.children).forEach((d, i) => d.classList.toggle('is-active', i === page));
      }
    }

    /* ---- Modal escribir reseña ---- */
    initModal() {
      this.modal = this.querySelector('[data-review-modal]');
      if (!this.modal) return;

      this.querySelectorAll('[data-open-review]').forEach((b) =>
        b.addEventListener('click', () => this.openModal())
      );
      this.modal.querySelectorAll('[data-close-review]').forEach((b) =>
        b.addEventListener('click', () => this.closeModal())
      );
      this._onKey = (e) => { if (e.key === 'Escape') this.closeModal(); };

      this.initRating();

      if (this.modal.querySelector('[data-review-posted]')) {
        this.openModal(true);
      }
    }

    initRating() {
      const wrap = this.modal.querySelector('[data-rate]');
      if (!wrap) return;
      const stars = Array.from(wrap.querySelectorAll('[data-rate-star]'));
      const inputs = Array.from(wrap.querySelectorAll('[data-rate-input]'));
      const paint = (n) => stars.forEach((s) => s.classList.toggle('is-on', +s.dataset.rateStar <= n));
      const checked = () => {
        const c = inputs.find((i) => i.checked);
        return c ? +c.dataset.rateInput : 0;
      };
      stars.forEach((s) => {
        s.addEventListener('mouseenter', () => paint(+s.dataset.rateStar));
      });
      inputs.forEach((i) => i.addEventListener('change', () => paint(checked())));
      wrap.addEventListener('mouseleave', () => paint(checked()));
      paint(checked());
    }

    openModal(skipFocus) {
      if (!this.modal) return;
      this.modal.hidden = false;
      document.body.classList.add('cb-rw-modal-open');
      document.addEventListener('keydown', this._onKey);
      if (!skipFocus) {
        const f = this.modal.querySelector('input, textarea, button.cb-rw__submit');
        if (f) f.focus();
      }
    }

    closeModal() {
      if (!this.modal) return;
      this.modal.hidden = true;
      document.body.classList.remove('cb-rw-modal-open');
      document.removeEventListener('keydown', this._onKey);
    }

    disconnectedCallback() {
      if (this._ro) this._ro.disconnect();
      if (this._onKey) document.removeEventListener('keydown', this._onKey);
      if (this._lbKey) document.removeEventListener('keydown', this._lbKey);
      document.body.classList.remove('cb-rw-modal-open');
      document.documentElement.style.overflow = '';
    }
  }
  if (!customElements.get('cb-reviews')) customElements.define('cb-reviews', CBReviews);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
